import React from 'react';
import moment from 'moment';
import DownloadLink from '../DownloadLink';
import CancelAction from '../../../Schedule/Component/Actions/CancelAction';
import RescheduleAction from '../../../Schedule/Component/Actions/RescheduleAction';

import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default function ReadyActions({ type, date, eventItem, rescheduleItem, cancelHandler }) {
  return <div>
    <OverlayTrigger placement="top" overlay={<Tooltip>View</Tooltip>} >
      <Link className="btn btn-outline-primary btn-sm" to={`/telehealth/${eventItem.id}/view`}><i className="fa fa-list-alt"></i></Link>
    </OverlayTrigger>
    &nbsp;
    <DownloadLink eventItem={eventItem} small />
    &nbsp;
    <RescheduleAction
      type={type}
      date={date}
      eventItem={eventItem}
      eventDoctor={{ value: eventItem.doctor.id, label: `${eventItem.providerGroup.firstName} ${eventItem.providerGroup.lastName}` }}
      eventProvider={{ value: eventItem.providerGroup.id, label: eventItem.name }}
      rescheduleItem={rescheduleItem}
      eventAvailableOn={eventItem.availableOn && eventItem.availableOn.date ? moment(eventItem.availableOn.date).toDate() : null}
    />
    &nbsp;
    <CancelAction type={type} cancelEventItem={() => {
      cancelHandler(eventItem)
    }} />
  </div>
}